import plusIcon from '../svg/plusIcon.svg';
import React from 'react';

const PlusIcon = () => <img src={plusIcon} />;

export default PlusIcon;
